import { defineSettingsScreen } from '@heidi/runtime/shell';

/**
 * Declares the Billing settings screen through the shell.
 */
export const billingSettingsScreen = defineSettingsScreen({
  id: 'billing',
  section: 'workspace',
  order: 2,
  load: () =>
    import('../ui/settings/billing/BillingSettings').then((module) => ({
      default: module.BillingSettings,
    })),
  builds: 'cloud-only',
});
